import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchHealthData } from "../../store/UserSlice";
import { RootState } from "../../store/store";
import { fetchProgramsAll } from "../../store/ProgramSlice";
import Testimonials from "../../components/Testimonial";
import { HealthCondition } from "../../interfaces/HealthCondition";
import { AllPrograms } from "../../interfaces/Program";
import { programsDetailsConfig } from "../../SliderProperties/ProgramConfig";
import { healthConfig } from "../../SliderProperties/HealthConfig";
import { ClientConfig } from "../../SliderProperties/ClientConfig";
import { Link } from "react-router-dom";

export default function Home() {
  const slider = useRef<Slider | null>(null);

  const previous = () => {
    (slider.current as any)?.slickPrev();
  };
  const next = () => {
    (slider.current as any)?.slickNext();
  };

  const dispatch = useDispatch<any>();
  const healthConditions = useSelector(
    (state: RootState) => state.user.data || []
  ) as HealthCondition[];

  const programsAll = useSelector((state: RootState) => {
    return state.programs.data || ([] as AllPrograms[]);
  });

  useEffect(() => {
    // Dispatch the fetchHealthData action to fetch health data
    dispatch(fetchHealthData());
  }, [dispatch]);

  useEffect(() => {
    // Dispatch the fetchHealthData acti 654789on to fetch health data
    dispatch(fetchProgramsAll({ search: "" }));
  }, [dispatch]);

  localStorage.removeItem('SetSlug');
  return (
    <>
      <div className="relative">
        <div
          className="bg-[#050333] bg-center text-center text-white h-auto md:h-[calc(100vh-25px )"      
        >  
     <video autoPlay loop muted className="h-auto pt-[5.5rem] md:pt-0 md:h-[calc(100vh-25px)] w-full object-cover ">
     <source src="https://seva-media.s3.eu-central-1.amazonaws.com/Y2meta.app-DEPART+SANTE-(1080p).mp4" type="video/mp4" />
    </video>
    <div className="absolute inset-0 bg-gradient-to-b from-[#2A2928] h-60"></div>
      </div>
      </div>

      <div
        className="bg-cover  bg-center"
        style={{ backgroundImage: `url("./images/bg1.png")` }}
      >
        <div className="container mx-auto border-b border-[#595959] flex items-center justify-center">
        <div className="text-center ">
          <img
            src="./images/rme.png"
            alt="Logo"
            className="p-6 max-w-fit m-auto transition-transform duration-300 hover:scale-95"
          />
        </div>
        <div className="text-center ">
          <img
            src="./images/asca.png"
            alt="Logo"
            className="p-6 max-w-fit transition-transform duration-300 hover:scale-95" //contrast-[.25]
          />
        </div>
      <Slider
        ref={(c) => (slider.current = c || null)}
        {...ClientConfig}
        className="pb-4 pt-8"
      >
        {/* <div className="text-center ">
          <img
            src="./images/rme.png"
            alt="Logo"
            className="p-4  max-w-fit m-auto transition-transform duration-300 hover:scale-95"
          />
        </div>
        <div className="text-center ">
          <img
            src="./images/asca.png"
            alt="Logo"
            className="p-4  max-w-fit transition-transform duration-300 hover:scale-95" //contrast-[.25]
          />
        </div> */}
        {/* <div className="text-center ">
          <img
            src="./images/company3.png"
            alt="Logo"
            className="p-4 contrast-[.25] max-w-fit transition-transform duration-300 hover:scale-95"
          />
        </div>
        <div className="text-center ">
          <img
            src="./images/company4.png"
            alt="Logo"
            className="p-4 contrast-[.25] max-w-fit transition-transform duration-300 hover:scale-95"
          />
        </div>
        <div className="text-center ">
          <img
            src="./images/company5.png"
            alt="Logo"
            className="p-4 contrast-[.25] max-w-fit transition-transform duration-300 hover:scale-95"
          />
        </div>
        <div className="text-center ">
          <img
            src="./images/company6.png"
            alt="Logo"
            className="p-4 contrast-[.25] max-w-fit transition-transform duration-300 hover:scale-95"
          />
        </div> */}
      </Slider>
    </div>
        <div className="container relative mx-auto my-10 items-center justify-center ">
          <h4 className="text-center text-xl text-[#9E9FBE] pt-8">Nos services</h4>
          <h2 className="text-center font-semibold text-2xl md:text-4xl  mt-2 p-4 capitalize text-white tracking-wide	mb-6">
          Prévenir et Mieux Guérir
          </h2>

          <Slider
            ref={(c) => (slider.current = c || null)}
            {...healthConfig}
            className="px-6 py-12 pr-8"
          >
            {healthConditions.map((healthCondition: HealthCondition) => (
              <div className="group cursor-pointer text-center relative flex justify-center mb-12 ">                
                <Link to='/programs/'
                        state={{ id : healthCondition.id }}
                      >   
                <div className="absolute duration-1000	 group-hover:bg-[#1D1A51] w-[80%] h-[80%] z-[-9] top-[10%] left-[10%] rounded-md "></div>
                <div className="group-hover:bg-[#252264] w-[70%] duration-1000 h-[80%] flex flex-col py-20 justify-center items-center m-auto rounded-md">
                  <img
                    src={healthCondition.icon}
                    alt="depression"
                    className="px-4 h-28 object-scale-down w-full"
                  />
                  <h3 className="mt-4 text-white text-xl capitalize">
                    {healthCondition.name}
                  </h3>
                </div>
                </Link>
              </div>
            ))}
          </Slider>

          <button onClick={previous} className="absolute top-[60%] left-10  md:left-1 transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 hover:scale-110">
            <svg
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[60%] md:w-full"
            >
              <g filter="url(#filter0_d_17_75)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M28.5 2C16.0751 2 6 12.0727 6 24.5C6 36.9249 16.0751 47 28.5 47C40.9249 47 51 36.9249 51 24.5C51 12.0727 40.9249 2 28.5 2Z"
                  stroke="#7C7D9B"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g filter="url(#filter1_d_17_75)">
                  <path
                    d="M32.0078 16.0565L23.5284 24.4995L32.0078 32.9425"
                    stroke="#7C7D9B"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    shape-rendering="crispEdges"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_d_17_75"
                  x="0.75"
                  y="0.75"
                  width="55.5"
                  height="55.5"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_17_75"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_17_75"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_d_17_75"
                  x="18.2784"
                  y="14.8065"
                  width="18.9795"
                  height="27.386"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_17_75"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_17_75"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>

          <button onClick={next} className="absolute top-[60%] -right-7 md:-right-4 transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 hover:scale-110">
            <svg
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[60%] md:w-full"
            >
              <g filter="url(#filter0_d_17_72)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M28.5 47C40.9249 47 51 36.9273 51 24.5C51 12.0751 40.9249 2 28.5 2C16.0751 2 6 12.0751 6 24.5C6 36.9273 16.0751 47 28.5 47Z"
                  stroke="#7C7D9B"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g filter="url(#filter1_d_17_72)">
                  <path
                    d="M24.9922 32.9435L33.4716 24.5005L24.9922 16.0575"
                    stroke="#7C7D9B"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    shape-rendering="crispEdges"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_d_17_72"
                  x="0.75"
                  y="0.75"
                  width="55.5"
                  height="55.5"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_17_72"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_17_72"
                    result="shape"
                  />
                </filter>
                <filter
                  id="filter1_d_17_72"
                  x="19.7422"
                  y="14.8075"
                  width="18.9795"
                  height="27.386"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_17_72"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_17_72"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>
        </div>
      </div>
      <div className="container mx-auto my-10 items-center justify-center text-center">
        <h4 className="text-center text-xl text-[#037897] pt-8">
        Nos Programmes       </h4> 
        <h2 className="text-center font-semibold text-2xl  md:text-4xl mt-2  p-4 capitalize text-[#020220] tracking-wide	mb-4">
        Des Solutions dans votre salon
        </h2>
        <a
                        href={`programs/`}
                        className="uppercase bg-[#037897] text-white py-3 my-4 font-bold rounded-md px-8 mb-8 " 
                      >
                        Tous les Programmes
                      </a>

        {programsAll.length > 0 && (
          <div className="my-6">
            <Slider {...programsDetailsConfig}>
              {programsAll.map((programs: AllPrograms) => {
                const formattedDate = new Intl.DateTimeFormat("en-US", {
                  weekday: "short",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                }).format(new Date(programs.startDate));

                return (
                  <div key={programs.id} className="p-4 max-w-xs md:max-w-5xl " >
                    
                   <a  href={`program/${programs.slug}`}> <img
                      src={
                        programs.icon
                      } /* Provide a valid source URL or remove if not needed */
                      alt=""
                      className="w-auto object-cover h-48 md:h-60 xl:h-80 transition-transform duration-300 hover:scale-95"
                    />
                     </a>
                    <div className="p-6 shadow-lg rounded-md mb-6 pb-8 text-left">
                      <div className="flex flex-wrap md:justify-between md:items-stretch mb-2">
                      <a  href={`program/${programs.slug}`}> <h3 className="text-xl w-80 font-semibold float-left leading-1 min-h-[10rem] md:min-h-[3.5rem]">
                          {programs.title}
                        </h3></a>
                        <span className="text-[#037897] font-bold text-xl float-right">
                          ${programs.cost}
                        </span>
                      </div>
                      <div className="flex flex-col md:flex-row md:justify-between md:items-stretch mb-6">
                        <div className="pr-4">
                          <span className="text-[#607D8B]">Date</span>
                          <p>{formattedDate}</p>
                        </div>
                        {/* <div className="pr-4">
            <span className="text-[#607D8B]">Time</span>
            <p>{programs.startTime} to {programs.endTime}</p>
          </div> */}
                        <div className="pr-4 ">
                          <span className="text-[#607D8B]">
                          Places réservées & disponibles
                          </span>
                          <p>
                            {(programs.maxParticipants < 9999) ? (
                              programs.bookedSlots ? `${programs.bookedSlots} / ${programs.maxParticipants}` : `0 / ${programs.maxParticipants}`
                            ) : "No limits"}
                          </p>

                        </div>
                        <div></div>
                      </div>
                      <a
                        href={`program/${programs.slug}`}
                        className="uppercase bg-[#037897] text-white py-3 my-4 font-bold rounded-md px-8"
                      >
                        Réserver Maintenant
                      </a>
                    </div>
                   
                  </div>
                );
              })}
            </Slider>
          </div>
        )}
      </div>
      <div className="container flex flex-col md:flex-row mx-auto my-10  items-center justify-center " id="about">
        <div className=" xl:basis-1/2">
          <img
            src="./images/about.png"
            alt="about"
            className="p-4 "
          />
        </div>
        <div className="basis-full xl:basis-1/2 p-3 md:p-3 xl:p-4">
          <h4 className="text-xl text-[#037897] ">Qui Sommes-Nous</h4>
          <h2 className="font-semibold text-2xl  md:text-4xl capitalize text-[#020220] tracking-wide mt-2	mb-5">
          Qu’est-ce que le DEPART SANTE?
          </h2>
          <p className="mb-2 text-[#546E7A]">
          Le DEPART SANTE est un programme fait pour vous aider chez vous. Chacun est différent et a des besoins différents. Nous sommes là pour répondre à vos besoins et vous aider à vous améliorer. Chaque lettre du DEPART SANTE représente un des outils qui sont à votre disposition au centre SEVA.
          </p>
          <p className="mb-2 text-[#546E7A]"><b>Detox:</b> La microtoxicité se trouve partout. En être conscient de comment mieux les éviter. Vous pouvez aussi apprendre des méthodes de détoxications adaptées à votre corps. La directrice du centre SEVA est une spécialiste en détoxication et a travaillé en collaboration avec les leaders de ce domaine. Elle est également spécialisée en préparation de dépose d’amalgames et a écrit le premier protocole de dépose d’amalgames dentaires en français. </p>
          <p className="mb-2 text-[#546E7A]"><b>Eau:</b> Notre corps est composé de 60% d’eau. Des changements, même minimes, peut entrainer des symptômes tels que de la fatigue, des maux de tête, de la constipation, du brouillard mental… </p>
          <p className="mb-2 text-[#546E7A]"><b>Posture:</b> L’équilibration du corps dans les trois dimensions de l’espace peut aider une multitude de problèmes. Que ce soit de la dépression, des migraines, des maux de dos, ou des problèmes gastro-intestinaux, chacun peut en bénéficier. Cette technique est aussi utilisée chez les sportifs pour améliorer leur potentiel.</p>
          <p className="mb-2 text-[#546E7A]"><b>Amitié/accueil:</b> Les relations interpersonnelles sont importantes pour un bon équilibre mental et physique.</p>
          <p className="mb-2 text-[#546E7A]"><b>Repos:</b> Le repos est primordial pour un bon fonctionnement du corps et de l’esprit. Apprenez comment non seulement avoir un meilleur sommeil, mais aussi comment mieux relaxer votre corps.</p>
          <p className="mb-2 text-[#546E7A]"><b>Travail:</b> Comment bien gérer son travail ? Comment prévenir et sortir du burn out? En moyenne, une personne passera 90’000 heures à travailler dans sa vie. Il est donc primordial de savoir trouver un équilibre dans sa vie professionnelle.</p>
          <p className="mb-2 text-[#546E7A]"><b>Soleil:</b> La lumière du soleil permet à la peau de produire la vitamine D. Elle permet aussi d’améliorer l’humeur et de réduire le stress. Elle améliore le sommeil, le système immunitaire et peut réduire la pression sanguine.</p>
          <p className="mb-2 text-[#546E7A]"><b>Air:</b> Vos poumons sont la porte d’entrée et de sortie de tous les gaz. Apprenez comment en prendre soin.</p>
          <p className="mb-2 text-[#546E7A]"><b>Nutrition:</b> Nous sommes fait de ce dont nous mangeons. Et par la nutrithérapie, vous pourrez aller encre plus loin et soigner certains par la nutrition.</p>
          <p className="mb-2 text-[#546E7A]"><b>Tempérance:</b> Les addictions sont un problème de plus en plus courant de nos jours. Apprenez à vous en débarrasser.</p>
          <p className="mb-2 text-[#546E7A]"><b>Exercice:</b> Les bienfaits de l’exercice physiques sont multiples. Apprenez des stratégies adaptées à vous pour vous mettre en mouvement et regagner de l’énergie.</p>
          
          <button className="uppercase bg-[#037897] text-white py-4 leading-3 font-bold rounded-md px-8 mt-2">
          Nous contacter
            <svg
              className="inline pl-2"
              width="24"
              height="15"
              viewBox="0 0 24 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 7.5H2"
                stroke="white"
                stroke-width="2.1"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.1914 2L22.715 7.49906L17.1914 13"
                stroke="white"
                stroke-width="2.1"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <Testimonials />
    </>
  );
}
